__webpack_require__.p = "/wp-content/themes/thelma-child/js/";